export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5/weather";
export const WEATHER_API_KEY = "d9f2af726c42791cde01fe0a2751f711";
export const MAPBOX_TOKEN =
  "pk.eyJ1IjoiY2Fyb2xpbmEtZGNmIiwiYSI6ImNsNmRxZjg3dTAwcHczaW9yOGtwbTIzZ2cifQ.b9Ojg2GBupuiC_DkIoKiaA";
